import { Component, Input } from '@angular/core';
import { PatientAttachmentHistoryItem } from 'app/core/models/patient-attachment-history-item.model';
import { ConsultNoteHistoryItemTitleComponent } from '../consult-note-history-item-title/consult-note-history-item-title.component';
import { ConsultNoteHistoryItemBodyComponent } from '../consult-note-history-item-body/consult-note-history-item-body.component';

@Component({
    selector: 'app-consult-note-history-item-type-base',
    templateUrl: './consult-note-history-item-type-base.component.html',
    imports: [ConsultNoteHistoryItemTitleComponent, ConsultNoteHistoryItemBodyComponent]
})
export class ConsultNoteHistoryItemTypeBaseComponent {
  @Input() patientAttachmentHistoryItem: PatientAttachmentHistoryItem;

  constructor() {}

  // This is meant as fallback text and shouldn't be shown in practice
  get title() {
    return `Event: ${this.patientAttachmentHistoryItem.action}`;
  }

  get description() {
    return '';
  }
}
